import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Text, Flex, useToast, Box } from '@chakra-ui/react';
import { Moment } from 'moment';
import { momentTimezone } from '../../utils/dateUtils';
import useForm, { TField } from '../../form/Form';
import Calendar from '../../calendar/Calendar';
import { addressInputskeys } from './ManageInputs';
import {
  addAppointment,
  deleteAppointment,
  updateAppointment,
} from '../../../api/planningApi';
import { TState, useActions } from '../../../redux/store';
import Modal from '../../modal/Modal';

const ManagePlanning = () => {
  const toast = useToast();
  const planningTab = useSelector((state: TState) => state.planningTab);
  const rowData = useSelector((state: TState) => state.rowData);
  const userList = useSelector((state: TState) => state.userList);
  const planningAddress = useSelector((state: TState) => state.planningAddress);
  const modalData = useSelector((state: TState) => state.modalData);

  const { onClose, fetchAppointments, getUsersList, setModalType, setRowData } =
    useActions();

  const [selectedDate, setSelectedDate] = useState<Moment>();

  useEffect(() => {
    getUsersList();
    fetchAppointments();
  }, []);

  const filteredUsers = userList.filter((user) => user.isPlanable);

  const usersOptions = filteredUsers.map((user) => ({
    label: user.name,
    value: user._id,
    color: user.userColor,
  }));

  const inputs: TField[] = [
    {
      name: planningAddress || 'planningAddress',
      label: 'RDV',
      type: 'address',
      noFormat: true,
    },
    {
      name: 'assignedUser',
      label: 'Assigné à',
      type: 'select',
      options: usersOptions,
    },
    {
      name: 'planningType',
      label: 'Type de rdv',
      type: 'select',
      options: planningTab?.planningType?.formOptions,
    },
  ];

  const { Form, formData } = useForm(inputs);

  const handlePlanning = async () => {
    const data: Record<string, any> = {
      rowId: rowData._id,
      planningDate:
        selectedDate &&
        momentTimezone(selectedDate).startOf('minute').toISOString(),
      assignedUser: formData.assignedUser,
      planningType: formData.planningType,
      planningAddress: formData[`${planningAddress}`],
      planningAddressDescription:
        formData[`${planningAddress}_addressDescription`],
      ...addressInputskeys.reduce(
        (prev, key) => ({
          ...prev,
          [`planningAddress_${key}`]: formData[`${planningAddress}_${key}`],
        }),
        {},
      ),
    };

    if (!data.planningDate || data.planningType == null) {
      // if (!data.planningDate || !data.assignedUser || data.planningType == null) {
      toast({
        status: 'error',
        title: 'Vous devez choisir un créneau et un type',
        // "Vous devez choisir un créneau, un type et assigner le rdv à quelqu'un",
      });
    } else {
      setSelectedDate(undefined);
      await addAppointment(data);
      await fetchAppointments();
      setRowData(modalData.original);
      setModalType('editEntry');
    }
  };

  const handleEditPlanning = async () => {
    const data: Record<string, any> = {
      planningDate:
        selectedDate &&
        momentTimezone(selectedDate).startOf('minute').toISOString(),
      assignedUser: formData.assignedUser,
      planningType: formData.planningType,
      planningAddress: formData.planningAddress,
      ...addressInputskeys.reduce(
        (prev, key) => ({
          ...prev,
          [`planningAddress_${key}`]: formData[`planningAddress_${key}`],
        }),
        {},
      ),
    };

    // if (!data.planningDate || !data.assignedUser || data.planningType == null) {
    if (!data.planningDate || data.planningType == null) {
      toast({
        status: 'error',
        title: 'Vous devez choisir un créneau et un type',
      });
    } else {
      setSelectedDate(undefined);
      await updateAppointment(rowData._id, data);
      await fetchAppointments();

      setRowData(modalData.original);
      setModalType('editEntry');
    }
  };

  const renderManagePlanning = (
    <>
      {/* switch entre calendar et MAP */}
      {/* <Switch /> */}
      <Calendar
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        datas={formData}
      >
        <Flex
          alignItems='flex-start'
          flexWrap='wrap'
          position='relative'
          zIndex={3}
        >
          <Text>Informations du RDV</Text>
          {Form.map((f, idx) => (
            <Box
              w={!idx ? '100%' : ['100%', '50%']}
              pl={[0, idx === 2 ? 3 : 0]}
            >
              {f}
            </Box>
          ))}
        </Flex>
      </Calendar>
    </>
  );

  const renderDeleteAppoint = <Text>Supprimer ce rdv ?</Text>;

  const handleDeletePlanning = async () => {
    await deleteAppointment(rowData._id);
    fetchAppointments();
    onClose();
  };

  const modalOptions = {
    addToPlanning: {
      component: renderManagePlanning,
      action: handlePlanning,
      title: 'Planifier un RDV',
      actionLabel: 'Valider',
    },
    updatePlanning: {
      component: renderManagePlanning,
      action: handleEditPlanning,
      title: 'Modifier un RDV',
      actionLabel: 'Sauvegarder',
    },
    deletePlanning: {
      component: renderDeleteAppoint,
      action: handleDeletePlanning,
      title: 'Supprimer un RDV',
      actionLabel: 'Confirmer',
    },
  };

  return <Modal options={modalOptions} />;
};

export default ManagePlanning;
